import React, { useState, useEffect } from "react";
import { Container, Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import "./Login.css";
import illustration from "../../../assets/ilustracao.png";
import logo from "../../../assets/Logo.png";
import { login } from "../../../api/auth/login";
import FlashMessage from "../../../components/common/FlashMessage";
import { useFlashMessage } from "../../../hooks/useFlashMessage";

interface LoginProps {
  onNavigate?: () => void;
}

const LoginPage: React.FC<LoginProps> = ({ onNavigate }) => {
  const navigate = useNavigate();
  const { setAuthUser, isAuthenticated } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { message, type, showMessage, clearMessage } = useFlashMessage(5000);
  // Se já está autenticado, redirecionar para a rota correta
  useEffect(() => {
    if (isAuthenticated) {
      navigate("/searchscreen");
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    login(email, password)
      .then((result) => {
        if (result.mfaRequired) {
          // MFA ativado — redirecionar para tela de código
          navigate("/verify-mfa", { state: { email: result.email } });
          return;
        }

        setAuthUser(result.session);
        navigate("/searchscreen");
      })
      .catch((error) => {
        if (error.isRateLimited) {
          showMessage(error.userMessage, "warning");
        } else if (error.isUnverified) {
          showMessage(
            "Conta não verificada. Verifique seu e-mail para continuar.",
            "warning"
          );
        } else {
          showMessage("Falha no login. Verifique suas credenciais.", "error");
        }
        setLoading(false);
      });
  };

  return (
    <Container fluid className="login-container">
      {message && (
        <div
          style={{
            position: "fixed",
            top: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 9999,
            minWidth: "400px",
          }}
        >
          <FlashMessage message={message} type={type} onClose={clearMessage} />
        </div>
      )}
      <div className="left-section">
        <div className="branding">
          <img
            src={logo}
            alt="Logo"
            className="logo"
            width={55}
            height={55}
            onClick={() => navigate("/home")}
          />
          <span className="brand-name">Insecta</span>
        </div>

        <div className="login-content">
          <h1 className="title">Entrar</h1>
          <h2 className="title">
            Acesse sua conta
            <br />
            para continuar.
          </h2>

          <p className="title">
            Se você não tem uma conta, registre-se.
            <br />
            Você pode se{" "}
            <a href="/register" className="register-link" onClick={onNavigate}>
              registrar aqui!
            </a>
          </p>
        </div>

        <div className="illustration-container">
          <img src={illustration} alt="Ilustração" className="illustration" />
        </div>
      </div>

      <div className="right-section">
        <div className="form-container">
          <p className="form-title">Insira suas informações abaixo</p>
          <Form onSubmit={handleSubmit} className="login-form">
            <Form.Group className="mb-3">
              <Form.Control
                type="email"
                placeholder="Entre com o e-mail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="form-input"
              />
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Control
                type="password"
                placeholder="Senha"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="form-input"
              />
            </Form.Group>

            <div className="forgot-password-container">
              <a href="/forgot-password" className="forgot-password">
                Esqueceu a senha?
              </a>
            </div>

            <Button type="submit" className="login-button" disabled={loading}>
              {loading ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  style={{ width: "1rem", height: "1rem" }}
                ></span>
              ) : (
                "Entrar"
              )}
            </Button>
          </Form>
        </div>
      </div>
    </Container>
  );
};

export default LoginPage;
